import {
  SidebarNav,
  NestedNavLink,
  DropDownMenu,
} from "@etframework/ui.components";
import { useTranslation } from "react-i18next";
import useModalEvent from "../../hooks/useModalEvent";
import Enums from "../../types/enums";

export const TaskTypesNavigation = ({ boardId, taskTypes }) => {
  const { t } = useTranslation(["TaskTypes"]);
  const { ModalEvents, toggleModal } = useModalEvent();

  const getDropdownOptions = () => [
    {
      id: "custom-task-type",
      text: t("CustomTaskType"),
      onClick: () => {
        toggleModal(ModalEvents.CreateTaskTypeModal);
      },
    },
    {
      id: "tax-return-task-type",
      text: t("TaxReturnTaskType"),
      onClick: () => {
        toggleModal(ModalEvents.CreateTaxReturnTaskTypeModal, {
          boardId: boardId,
        });
      },
      disabled: taskTypes?.some(
        (taskType) => taskType.Type === Enums.TaskType.TaxReturn
      ),
    },
  ];

  const handleSelectMenuItem = (args) => {
    args?.onClick?.();
  };

  return (
    <>
      <div className="et-layout-nav-header d-flex justify-content-between mx-3 my-2">
        <span>{t("TaskTypes")}</span>
        <DropDownMenu
          id={"dd_settings_board-settings_navigation_task-type-add"}
          select={handleSelectMenuItem}
          hideChevron={true}
          items={getDropdownOptions()}
        >
          <div className="d-flex align-items-center gap-2 add-task-type-btn">
            <i className="fa-regular fa-plus"></i>
            <div className="button-text fw-600">{t("Add")}</div>
          </div>
        </DropDownMenu>
      </div>
      <SidebarNav>
        {
          taskTypes?.map((taskType, index) => (
            <NestedNavLink
              id={
                "dd_settings_board-settings_navigation_task-type-" +
                index +
                "-link"
              }
              key={index}
              to={`/duedates/settings/boards/${boardId}/tasktypes/${taskType?.Id}`}
              end={false}
            >
              {taskType.Title}
            </NestedNavLink>
          )) || <div key={1}></div> /* This guy needs children */
        }
      </SidebarNav>
    </>
  );
};
